<!-- Copyright 2025, Common Good Learning Tools LLC -->
<template>
	<div>
		<v-tooltip bottom>
			<template v-slot:activator="{ on }">
				<v-icon v-on="on" class="mr-4" ref="button" @click="comment">far fa-comment</v-icon>
			</template>
			<span>Add/View Comment(s)</span>
		</v-tooltip>

		<div
			v-show="comments_open"
			class="comments"
			ref="comments"
			:style="position"
			draggable
			@dragstart="drag_start"
			@dragend="drag_end"
			@drag="drag"
		>
			<div class="d-flex align-center">
				<div class="title">Add/View Comment(s)</div>

				<v-spacer/>

				<!-- <v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-icon v-on="on" class="drag-handle mr-3">fas fa-arrows-alt</v-icon>
					</template>
					Click and drag to reposition
				</v-tooltip> -->

				<v-btn color="secondary" dark small @click="comments_open = false">
					<v-icon small class="mr-2">fas fa-times</v-icon>
					Done
				</v-btn>
			</div>
			<div>Comments</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Comments',

	props: {
		reference_id: {type: String, required: true}
	},

	data() {
		return {
			comments_open: false,
			coordinates: {x: -570, y: 6},
			is_dragging: false,
		}
	},

	computed: {
		position() {
			return {
				transform: `translate(${this.coordinates.x}px, ${this.coordinates.y}px)`
			}
		}
	},

	mounted() {
	},

	methods: {
		comment() {
			this.comments_open = true
		},

		drag_start(event) {
			let button = this.$refs.button.$el.getBoundingClientRect()
			let comments = this.$refs.comments.getBoundingClientRect()
			this.is_dragging = true
			event.dataTransfer.setData('text/plain', 'Dragging')
			console.log(this.coordinates, comments, button)
		},

		drag_end() {
			let button = this.$refs.button.$el.getBoundingClientRect()
			this.is_dragging = false
			console.log(this.coordinates, button)
		},

		drag(event) {
			if (this.is_dragging && event.clientX && event.clientY) {
				this.coordinates = {
					x: event.clientX,
					y: event.clientY,
				}
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.comments {
	position: fixed;
	width: 600px;
	height: 400px;
	padding: 16px;
	background-color: white;
	border-radius: 12px;
	box-shadow: 8px 8px 8px rgba(0, 0, 0, 0.125);
	border: 1px solid rgba(0, 0, 0, 0.125);
	z-index: 100000;

	.drag-handle {
		cursor: grab;

		&:hover:active {
			cursor: grabbing;
		}
	}
}
</style>